<kui-modal #modal
    size="lg"
    [title]="data.heading || 'DIALOG.INFORMATION' | translate"
    [actions]="modalActions"
    (onClose)="detachModal()">
    <div class="p-4">
        <ngx-json-viewer [json]="data.object"></ngx-json-viewer>
    </div>
</kui-modal>